
import {  
  Fun, 
  nothing, 
  route 
} from 'widgets-for-react'
import { ProxyPaths } from '../../../custom_views/app'
import { styleguide as SG } from '../../../styleguide/main'
import { CustomRouteParams } from '../../cms/router/type.gen'
import { PublicSiteState } from '../../public_site.main.mod'
import { 
  CustomPage, 
  CustomPagesState, 
  PublicSiteCustomRoutes 
} from './types.mod'

export const styleguide: CustomPage<CustomPagesState['styleguide']> = {
  widget: () => SG.never(),
  route: route<{}, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>('/styleguide', () => ({
    kind: 'styleguide'
  })),
  getState: (s: PublicSiteState) => s.styleguide,
  setState: (s: PublicSiteState, ss: {}) => ({ ...s, styleguide: ss }),
  updateStateBasesOnRoute: (s, r) => (r.kind !== 'styleguide' ? s : { ...s, styleguide: { ...s.styleguide } })
}

export const proxy_page: Fun<ProxyPaths, CustomPage<{}>> = proxyPaths => ({
  widget: () => nothing(),
  route: route<{}, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>(
    // @ts-ignore: array of strings is an allowed value of <Route path>.
    proxyPaths.map(r => r + '*'),
    () => ({ kind: 'proxy_page' })
  ),
  getState: (s: PublicSiteState) => s,
  setState: (s: PublicSiteState) => s,
  updateStateBasesOnRoute: (s, r) => s
})

